module.exports = __webpack_public_path__ + "img/thg-logo.fc38f3df.svg";